/* transformTestData.ts */

/* Interfaces */
import { TestDataProps } from "src/shared/interfaces/common/TestData";

/* Utils */
import { MAIN_CONDITION_MAPPER } from "src/utils/mapper/mainConditionMapper";
import { toCamelCase } from "src/utils/helper/string-transformation";

interface GroupedDataProps {
  [key: string]: TestDataProps[];
}

const groupDataByDate = (
  data: TestDataProps[]
): GroupedDataProps => {
  return data.reduce((acc: GroupedDataProps, item) => {
    const code = item.condition ?? "";
    /**
     * Mapper `MAIN_CONDITION_MAPPER` is used to convert
     * conditionId to full name of main condition.
     * Example: c_91_1 -> C91.1 B-cell chronic lymphocytic leukemia.
     */
    const displayName = MAIN_CONDITION_MAPPER[code] ?? code;

    if (!acc[displayName]) {
      acc[displayName] = [];
    }

    acc[displayName].push(item);
    return acc;
  }, {});
};

export const transformTestData = (
  data: TestDataProps[]
) => {
  const transformedData = groupDataByDate(
    toCamelCase(data)
  );
  return transformedData;
};
